import { Injectable } from '@angular/core'

import { ADMIN_API_ENDPOINTS } from '../../common/api-endpoints'
import { ChallengeConfigDto } from '../../dto'
import { HttpService } from '../http.service'

/**
 * FR-08 — cấu hình dùng chung cho toàn bộ Challenge.
 *
 * API #1 `GET /admin/v1/stamp-collection/challenge-configuration`
 * API #2 `PUT /admin/v1/stamp-collection/challenge-configuration`
 *
 * ✅ ĐÃ LIVE (OpenAPI 2026-08-25) — mock đã gỡ hoàn toàn.
 * ✅ Request + response khớp 100% với `ChallengeConfigDto`, không cần mapper.
 */
@Injectable({
  providedIn: 'root'
})
export class AdminChallengeConfigService {

  constructor(private httpService: HttpService) {}

  /** API #1 — snapshot cấu hình đang có hiệu lực. */
  public async get(): Promise<ChallengeConfigDto> {
    return await this.httpService.get<ChallengeConfigDto>(
      ADMIN_API_ENDPOINTS.CHALLENGE_CONFIGURATION
    )
  }

  /**
   * API #2 — tạo snapshot mới (BE: *"Update the Challenge configuration (new snapshot)"*).
   *
   * ⚠️ Body OpenAPI chỉ nhận đúng 6 số, **không có** `id`. Màn Settings
   * giữ nguyên object đã load từ API #1 nên phải pick tường minh, tránh 400 do
   * whitelist validation.
   */
  public async update(data: ChallengeConfigDto): Promise<ChallengeConfigDto> {
    const body = {
      rewardLowStockThreshold: data.rewardLowStockThreshold,
      challengeEndingSoonDays: data.challengeEndingSoonDays,
      redemptionEndingSoonDays: data.redemptionEndingSoonDays,
      milestoneLimit: data.milestoneLimit,
      rewardTierLimit: data.rewardTierLimit,
      rewardOptionLimit: data.rewardOptionLimit
    }

    return await this.httpService.put<ChallengeConfigDto>(
      ADMIN_API_ENDPOINTS.CHALLENGE_CONFIGURATION,
      body
    )
  }
}
